import { UpdateStateProvider } from './updateStatusConext/UpdateTaskContext';
export const rootContext = [UpdateStateProvider];
